module.exports = "/fonts/glyphicons-halflings-regular.ttf";